import LogoGradientIcon from '../../icons/LogoGradientIcon'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectUser, setSession } from '../../reducers/users'
import { SessionState } from '../../types/UserTypes'
import { IconChevronRight } from '@tabler/icons-react'
import { inPov } from '../../utils/session'
import { selectGroup } from '../../reducers/groups'

interface IGroupsHeaderProps {
  pageTitle: string
}

const GroupsHeader = (props: IGroupsHeaderProps) => {
  const { pageTitle } = props

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { session, currentPage } = useSelector(selectUser)
  const { userGroup } = useSelector(selectGroup)

  useEffect(() => {
    const goToConfigured = localStorage.getItem('SSO_CONFIGURED_COOKIE')

    if (goToConfigured === 'true') {
      navigate('/settings')
    }
    if (window.location.search.includes('error=sso-unauthorized')) {
      navigate('/sso-error')
    }
  }, [])

  useEffect(() => {
    const storedSession = localStorage.getItem('session') as string

    if (currentPage === 'SSO_ERROR') {
      localStorage.setItem('session', '{}')
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
      dispatch(setSession(undefined))
    } else if (!session && storedSession === '{}' && currentPage !== 'SSO_ERROR') {
      localStorage.setItem('session', '{}')
      localStorage.removeItem('SSO_CONFIGURED_COOKIE')
      dispatch(setSession(undefined))
      navigate('/login')
    } else if (!session && storedSession !== '{}') {
      dispatch(setSession(JSON.parse(storedSession) as SessionState))
    }
  }, [session])

  useEffect(() => {
    if (import.meta.env.VITE_PRETTY_ENV !== 'Production' && import.meta.env.VITE_ON_PREM === 'false') {
      document.title = '[' + import.meta.env.VITE_PRETTY_ENV + '] ' + 'iVerify EDR Portal'
    }
  }, [])

  return (
    <>
      <div className="w-full absolute h-[74px] flex items-center px-6" style={{ top: inPov(session) ? '42px' : '0px' }}>
        <div className="flex items-center min-w-0 flex-1">
          <div className="h-[26px] w-[182px] shrink-0">
            <LogoGradientIcon height="26" width="71" />
          </div>
          <div className="ml-4 flex items-center overflow-hidden whitespace-nowrap text-ellipsis">
            <div
              className="font-semibold text-neutral-11 dark:text-neutral-9 text-xl cursor-pointer shrink-0"
              onClick={() => navigate('/groups')}
            >
              {pageTitle}
            </div>
            <IconChevronRight size={18} className="text-neutral-11 dark:text-neutral-9 mx-1.5 shrink-0" />
            <div className="font-semibold text-xl text-mainText truncate max-w-[400px]">{userGroup?.name}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GroupsHeader
